import axios from 'axios'

export const fetchMusicXmlDocument = async (url: string): Promise<Document> => {
  const { data } = await axios.get<string>(url, { responseType: 'text' })

  const parsed = new DOMParser().parseFromString(data, 'application/xml')

  if (parsed.getElementsByTagName('parsererror').length) {
    throw new Error('Invalid MusicXML document')
  }

  return parsed
}
